<template>
  <svg
    width="51px"
    height="49px"
    viewBox="0 0 51 49"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Bag Icon</title>
    <defs>
      <polygon
        id="path-1"
        points="0 0 12.2788 0 12.2788 41.537 0 41.537"
      ></polygon>
      <polygon
        id="path-3"
        points="1.77635684e-15 0 10.06 0 10.06 8.6789 1.77635684e-15 8.6789"
      ></polygon>
      <polygon
        id="path-5"
        points="3.55271368e-15 0 14.286 0 14.286 8.6789 3.55271368e-15 8.6789"
      ></polygon>
      <polygon
        id="path-7"
        points="0 48.716 50.334 48.716 50.334 0 0 0"
      ></polygon>
    </defs>
    <g
      id="Designs"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="AG-Grid"
        transform="translate(-825, -378)"
      >
        <g
          id="Group-42"
          transform="translate(825, 378)"
        >
          <path
            d="M24.6408,2.7723 L24.6408,7.9283 L37.4268,7.9283 L37.4268,3.5153 C37.4268,3.1053 37.0938,2.7723 36.6838,2.7723 L24.6408,2.7723 Z"
            id="Fill-1"
            fill="#FBF1C7"
          ></path>
          <path
            d="M25.3906,7.1789 L36.6766,7.1789 L36.6766,3.5149 L25.3906,3.5219 L25.3906,7.1789 Z M37.4266,8.6789 L24.6406,8.6789 C24.2266,8.6789 23.8906,8.3429 23.8906,7.9289 L23.8906,2.7719 C23.8906,2.3579 24.2266,2.0219 24.6406,2.0219 L36.6836,2.0219 C37.5066,2.0219 38.1766,2.6919 38.1766,3.5149 L38.1766,7.9289 C38.1766,8.3429 37.8406,8.6789 37.4266,8.6789 L37.4266,8.6789 Z"
            id="Fill-3"
            fill="#000000"
          ></path>
          <path
            d="M0.7503,9.1041 L0.7503,46.7911 C0.7503,47.4401 1.2763,47.9661 1.9253,47.9661 L10.3533,47.9661 C11.0023,47.9661 11.5283,47.4401 11.5283,46.7911 L11.5283,9.1041 C11.5283,8.4551 11.0023,7.9291 10.3533,7.9291 L1.9253,7.9291 C1.2763,7.9291 0.7503,8.4551 0.7503,9.1041"
            id="Fill-5"
            fill="#DFF4FB"
          ></path>
          <g
            id="Group-9"
            transform="translate(0, 7.1789)"
          >
            <mask
              id="mask-2"
              fill="white"
            >
              <use xlink:href="#path-1"></use>
            </mask>
            <g id="Clip-8"></g>
            <path
              d="M1.9258,1.5 C1.6918,1.5 1.4998,1.691 1.4998,1.925 L1.4998,39.612 C1.4998,39.846 1.6918,40.037 1.9258,40.037 L10.3538,40.037 C10.5878,40.037 10.7788,39.846 10.7788,39.612 L10.7788,1.925 C10.7788,1.691 10.5878,1.5 10.3538,1.5 L1.9258,1.5 Z M10.3538,41.537 L1.9258,41.537 C0.8638,41.537 -0.0002,40.673 -0.0002,39.612 L-0.0002,1.925 C-0.0002,0.864 0.8638,0 1.9258,0 L10.3538,0 C11.4148,0 12.2788,0.864 12.2788,1.925 L12.2788,39.612 C12.2788,40.673 11.4148,41.537 10.3538,41.537 L10.3538,41.537 Z"
              id="Fill-7"
              fill="#000000"
              mask="url(#mask-2)"
            ></path>
          </g>
          <path
            d="M42.1892,9.0247 L42.1892,46.8707 C42.1892,47.4757 41.6982,47.9657 41.0932,47.9657 L10.6242,47.9657 C10.0192,47.9657 9.5282,47.4757 9.5282,46.8707 L9.5282,9.0247 C9.5282,8.4197 10.0192,7.9287 10.6242,7.9287 L41.0932,7.9287 C41.6982,7.9287 42.1892,8.4197 42.1892,9.0247"
            id="Fill-10"
            fill="#FFFFFF"
          ></path>
          <path
            d="M10.624,8.6789 C10.434,8.6789 10.278,8.8339 10.278,9.0249 L10.278,46.8699 C10.278,47.0609 10.434,47.2159 10.624,47.2159 L41.094,47.2159 C41.284,47.2159 41.439,47.0609 41.439,46.8699 L41.439,9.0249 C41.439,8.8339 41.284,8.6789 41.094,8.6789 L10.624,8.6789 Z M41.094,48.7159 L10.624,48.7159 C9.606,48.7159 8.778,47.8879 8.778,46.8699 L8.778,9.0249 C8.778,8.0069 9.606,7.1789 10.624,7.1789 L41.094,7.1789 C42.111,7.1789 42.939,8.0069 42.939,9.0249 L42.939,46.8699 C42.939,47.8879 42.111,48.7159 41.094,48.7159 L41.094,48.7159 Z"
            id="Fill-12"
            fill="#000000"
          ></path>
          <path
            d="M25.8584,28.9894 C21.9414,28.9894 18.7544,25.8024 18.7544,21.8854 L18.7544,15.4084 C18.7544,14.9944 19.0904,14.6584 19.5044,14.6584 C19.9194,14.6584 20.2544,14.9944 20.2544,15.4084 L20.2544,21.8854 C20.2544,24.9754 22.7684,27.4894 25.8584,27.4894 C28.9484,27.4894 31.4624,24.9754 31.4624,21.8854 L31.4624,15.4084 C31.4624,14.9944 31.7984,14.6584 32.2124,14.6584 C32.6274,14.6584 32.9624,14.9944 32.9624,15.4084 L32.9624,21.8854 C32.9624,25.8024 29.7754,28.9894 25.8584,28.9894"
            id="Fill-14"
            fill="#000000"
          ></path>
          <path
            d="M14.2763,0.7497 L14.2763,7.9287 L5.7163,7.9287 L5.7163,1.4927 C5.7163,1.0827 6.0493,0.7497 6.4593,0.7497 L14.2763,0.7497 Z"
            id="Fill-16"
            fill="#FDE9F3"
          ></path>
          <g
            id="Group-20"
            transform="translate(4.9668, 0)"
          >
            <mask
              id="mask-4"
              fill="white"
            >
              <use xlink:href="#path-3"></use>
            </mask>
            <g id="Clip-19"></g>
            <path
              d="M1.499,7.1789 L8.56,7.1789 L8.56,1.4999 L1.493,1.4999 L1.499,7.1789 Z M9.31,8.6789 L0.75,8.6789 C0.336,8.6789 1.77635684e-15,8.3429 1.77635684e-15,7.9289 L1.77635684e-15,1.4929 C1.77635684e-15,0.6699 0.67,-0.0001 1.493,-0.0001 L9.31,-0.0001 C9.724,-0.0001 10.06,0.3359 10.06,0.7499 L10.06,7.9289 C10.06,8.3429 9.724,8.6789 9.31,8.6789 L9.31,8.6789 Z"
              id="Fill-18"
              fill="#000000"
              mask="url(#mask-4)"
            ></path>
          </g>
          <path
            d="M14.2763,0.7497 L14.2763,7.9287 L27.0623,7.9287 L27.0623,1.4927 C27.0623,1.0827 26.7293,0.7497 26.3193,0.7497 L14.2763,0.7497 Z"
            id="Fill-21"
            fill="#DFFADF"
          ></path>
          <g
            id="Group-25"
            transform="translate(13.5264, 0)"
          >
            <mask
              id="mask-6"
              fill="white"
            >
              <use xlink:href="#path-5"></use>
            </mask>
            <g id="Clip-24"></g>
            <path
              d="M1.5,7.1789 L12.786,7.1789 L12.786,1.4929 L1.5,1.4989 L1.5,7.1789 Z M13.536,8.6789 L0.75,8.6789 C0.336,8.6789 3.55271368e-15,8.3429 3.55271368e-15,7.9289 L3.55271368e-15,0.7499 C3.55271368e-15,0.3359 0.336,-0.0001 0.75,-0.0001 L12.793,-0.0001 C13.616,-0.0001 14.286,0.6699 14.286,1.4929 L14.286,7.9289 C14.286,8.3429 13.95,8.6789 13.536,8.6789 L13.536,8.6789 Z"
              id="Fill-23"
              fill="#000000"
              mask="url(#mask-6)"
            ></path>
          </g>
          <path
            d="M21.3703,15.5983 C21.3703,16.6243 20.5293,17.4563 19.5043,17.4563 C18.4783,17.4563 17.6383,16.6243 17.6383,15.5983 C17.6383,14.5643 18.4783,13.7323 19.5043,13.7323 C20.5293,13.7323 21.3703,14.5643 21.3703,15.5983"
            id="Fill-26"
            fill="#FFFFFF"
          ></path>
          <path
            d="M19.5039,14.4821 C18.8889,14.4821 18.3879,14.9821 18.3879,15.5981 C18.3879,16.2091 18.8889,16.7061 19.5039,16.7061 C20.1189,16.7061 20.6199,16.2091 20.6199,15.5981 C20.6199,14.9821 20.1189,14.4821 19.5039,14.4821 M19.5039,18.2061 C18.0619,18.2061 16.8879,17.0361 16.8879,15.5981 C16.8879,14.1561 18.0619,12.9821 19.5039,12.9821 C20.9459,12.9821 22.1199,14.1561 22.1199,15.5981 C22.1199,17.0361 20.9459,18.2061 19.5039,18.2061"
            id="Fill-28"
            fill="#000000"
          ></path>
          <path
            d="M34.0795,15.5983 C34.0795,16.6243 33.2385,17.4563 32.2135,17.4563 C31.1875,17.4563 30.3475,16.6243 30.3475,15.5983 C30.3475,14.5643 31.1875,13.7323 32.2135,13.7323 C33.2385,13.7323 34.0795,14.5643 34.0795,15.5983"
            id="Fill-30"
            fill="#FFFFFF"
          ></path>
          <path
            d="M32.2129,14.4821 C31.5979,14.4821 31.0979,14.9821 31.0979,15.5981 C31.0979,16.2091 31.5979,16.7061 32.2129,16.7061 C32.8279,16.7061 33.3289,16.2091 33.3289,15.5981 C33.3289,14.9821 32.8279,14.4821 32.2129,14.4821 M32.2129,18.2061 C30.7709,18.2061 29.5979,17.0361 29.5979,15.5981 C29.5979,14.1561 30.7709,12.9821 32.2129,12.9821 C33.6549,12.9821 34.8289,14.1561 34.8289,15.5981 C34.8289,17.0361 33.6549,18.2061 32.2129,18.2061"
            id="Fill-32"
            fill="#000000"
          ></path>
          <path
            d="M49.5843,33.3261 L49.5843,46.7461 C49.5843,47.4261 49.0443,47.9661 48.3643,47.9661 L25.1443,47.9661 C24.4743,47.9661 23.9243,47.4261 23.9243,46.7461 L23.9243,33.3261 C23.9243,32.6561 24.4743,32.1161 25.1443,32.1161 L48.3643,32.1161 C49.0443,32.1161 49.5843,32.6561 49.5843,33.3261"
            id="Fill-34"
            fill="#FFFFFF"
          ></path>
          <path
            d="M25.1445,32.8659 C24.8845,32.8659 24.6735,33.0729 24.6735,33.3259 L24.6735,46.7459 C24.6735,47.0049 24.8845,47.2159 25.1445,47.2159 L48.3645,47.2159 C48.6275,47.2159 48.8335,47.0099 48.8335,46.7459 L48.8335,33.3259 C48.8335,33.0679 48.6275,32.8659 48.3645,32.8659 L25.1445,32.8659 Z M48.3645,48.7159 L25.1445,48.7159 C24.0575,48.7159 23.1735,47.8319 23.1735,46.7459 L23.1735,33.3259 C23.1735,32.2449 24.0575,31.3659 25.1445,31.3659 L48.3645,31.3659 C49.4505,31.3659 50.3335,32.2449 50.3335,33.3259 L50.3335,46.7459 C50.3335,47.8319 49.4505,48.7159 48.3645,48.7159 L48.3645,48.7159 Z"
            id="Fill-36"
            fill="#000000"
          ></path>
          <mask
            id="mask-8"
            fill="white"
          >
            <use xlink:href="#path-7"></use>
          </mask>
          <g id="Clip-39"></g>
          <polygon
            id="Fill-38"
            fill="#DFFADF"
            mask="url(#mask-8)"
            points="23.924 39.496 49.584 39.496 49.584 35.686 23.924 35.686"
          ></polygon>
          <path
            d="M24.674,38.746 L48.834,38.746 L48.834,36.436 L24.674,36.436 L24.674,38.746 Z M49.584,40.246 L23.924,40.246 C23.51,40.246 23.174,39.91 23.174,39.496 L23.174,35.686 C23.174,35.272 23.51,34.936 23.924,34.936 L49.584,34.936 C49.998,34.936 50.334,35.272 50.334,35.686 L50.334,39.496 C50.334,39.91 49.998,40.246 49.584,40.246 L49.584,40.246 Z"
            id="Fill-40"
            fill="#000000"
            mask="url(#mask-8)"
          ></path>
          <path
            d="M45.3945,44.6457 L42.6545,44.6457 C42.2405,44.6457 41.9045,44.3097 41.9045,43.8957 C41.9045,43.4817 42.2405,43.1457 42.6545,43.1457 L45.3945,43.1457 C45.8085,43.1457 46.1445,43.4817 46.1445,43.8957 C46.1445,44.3097 45.8085,44.6457 45.3945,44.6457"
            id="Fill-41"
            fill="#000000"
            mask="url(#mask-8)"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
